import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { MdError } from "react-icons/md";
import { Button } from "src/components";
import styles from "./AccountRejected.module.scss";

interface AccountRejectedProps {
  onLogout?: () => void;
}

export const AccountRejected: React.FC<AccountRejectedProps> = ({ onLogout }) => {
  const { logout } = useAuth0();

  const handleLogout = () => {
    if (onLogout) {
      onLogout();
    }
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  };

  return (
    <div className={styles.pagelayout}>
      <div className={styles.logout} onClick={handleLogout}>
        Logout
      </div>
      <div className={styles.pagecontent}>
        <div className={styles.errorIcon}>
          <MdError size={48} />
        </div>
        <h1>Your account is rejected</h1>
        <p>
          Your account application has been reviewed and unfortunately cannot be approved. 
          This decision is based on our current policy requirements and verification standards.
        </p>
        <p>
          If you believe this is an incorrect decision, please contact us at{" "}
          <a href="mailto:chain@pocketsflow.com" className={styles.emailLink}>
            chain@pocketsflow.com
          </a>
        </p>
        <div className={styles.contactButton}>
          <Button
            text="Contact Support"
            onClick={() => window.open("mailto:chain@pocketsflow.com", "_self")}
            variant="primary"
          />
        </div>
      </div>
    </div>
  );
}; 